import React, { useEffect, useState } from "react";
import StepWizard from "react-step-wizard";
import Profilesidebar from "./../components/Element/Profilesidebar";
import Nav from "../components/Element/EmployementHistory/Nav";
import References from "../components/Element/EmployementHistory";
import UserExperience from "../containers/UserExperience";
import { isMobileOrLaptop } from "../services/CheckDevice";
import ProfileSideBarMobile from "../components/Element/ProfileSideBarMobile";
// import composedCandidateJobProfileWorkQualification from "../containers/CandidateJobProfileWorkQualification";
const EmployementRefrence = (props) => {
  // Check Device - Start
  const [checkDevice, setCheckDevice] = useState("Mobile");

  window.addEventListener("resize", function () {
    // Call the function when the screen size changes
    const deviceType = isMobileOrLaptop();
    setCheckDevice(deviceType);
  });

  useEffect(() => {
    const deviceType = isMobileOrLaptop(350);
    setCheckDevice(deviceType);
  }, []);
  // Check Device - End

  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <div className="content-block">
          <div className="section-full bg-white browse-job p-t50 p-b20">
            <div className="container">
              <div className="row">
                {checkDevice && checkDevice === "Mobile" ? (
                  <ProfileSideBarMobile page={"emplyement-references"} />
                ) : (
                  <Profilesidebar page={"emplyement-references"} />
                )}

                <div className="col-xl-9 col-lg-8 m-b30">
                  <StepWizard nav={<Nav />} isLazyMount={true}>
                    <References />
                    {/* <EmployementGapForm/> */}
                  </StepWizard>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserExperience(EmployementRefrence);
// export default composedCandidateJobProfileWorkQualification(EmployementRefrence);
